import React, { Component, RefObject } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import FateRefreshTooltip from "./FateRefreshTooltip";

export interface Props {
  dispatch: Function,
  go: boolean | undefined,
  hasEnoughFate?: boolean | undefined,
  onOpenActionRefreshModal: Function,
  onOpenPurchaseFateModal: Function,
}

class FateRefreshButton extends Component<Props, {}> {
  static displayName = 'FateRefreshButton';

  static defaultProps = {
    go: false,
    hasEnoughFate: false,
  };

  element: RefObject<any>;

  constructor(props: Props) {
    super(props);
    this.element = React.createRef();
  }

  state = {
    isTooltipActive: false,
  };

  handleClick = () => {
    const {
      hasEnoughFate,
      onOpenActionRefreshModal,
      onOpenPurchaseFateModal,
    } = this.props;
    if (hasEnoughFate) {
      return onOpenActionRefreshModal();
    }
    return onOpenPurchaseFateModal();
  };

  hideTooltip = () => {
    this.setState({ isTooltipActive: false });
  };

  showTooltip = () => {
    this.setState({ isTooltipActive: true });
  };

  render() {
    const { go, hasEnoughFate } = this.props;
    const { isTooltipActive } = this.state;

    return (
      <button
        className={classnames(
          'js-tt button button--secondary button--margin',
          go && 'button--go',
        )}
        onClick={this.handleClick}
        onMouseEnter={this.showTooltip}
        onMouseLeave={this.hideTooltip}
        ref={this.element}
        type="button"
      >
        {hasEnoughFate ? 'Refresh' : 'Unlock'}
        <FateRefreshTooltip
          active={isTooltipActive}
          hasEnoughFate={hasEnoughFate || false}
          parent={this.element.current}
        />
      </button>
    );
  }
}

export default connect()(FateRefreshButton);